<script lang="ts">
	import { onMount } from "svelte";
	export let editMode = false;
	export let position: {
		lat: string;
		lng: string;
	};
	let mapBox: HTMLDivElement;

	const onLoadKakaoMap = () => {
		window.kakao.maps.load(() => {
			let container = mapBox;
			let options = {
				center: new window.kakao.maps.LatLng(position.lat, position.lng),
				level: 2,
			};

			let map = new window.kakao.maps.Map(container, options);

			const imageSrc = "/img/MapMarker.png";
			// 마커 이미지 크기
			const imageSize = new window.kakao.maps.Size(36, 44);

			let markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize);
			// 맵 안에 위치시킬 마커의 좌표
			let markerPosition = new window.kakao.maps.LatLng(
				position.lat,
				position.lng
			);

			let marker = new window.kakao.maps.Marker({
				position: markerPosition,
				image: markerImage,
			});

			marker.setMap(map);
		});
	};

	onMount(() => {
		//Reason : Mount 될 때마다 스크립트가 추가로 생성되는 것을 방지
		if (window.kakao) {
			onLoadKakaoMap();
			return;
		}

		const mapScript = document.createElement("script");
		mapScript.async = true;
		mapScript.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${"KAKAO_MAP_KEY"}&autoload=false`;
		document.head.appendChild(mapScript);
		mapScript.addEventListener("load", onLoadKakaoMap);
	});

</script>

<div class="container">
	<div id="map" bind:this={mapBox}>
		<div
			class="whiteCover"
			style={`display : ${editMode ? 'block' : 'none'}`}
			on:click|stopPropagation />
	</div>
</div>

<style lang="scss">
	.container {
		width: 100%;
		position: relative;

		&:after {
			content: "";
			display: block;
			padding-bottom: 100%;
		}

		#map {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	.whiteCover {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(255, 255, 255, 0.5);
		z-index: 99;
	}

</style>
